"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AllCategoriesQuery = (0, graphql_tag_1.default)(`
  query allCategoriesQuery($storeId: String) {
    allCategories: category(
      categoryRequest: { metadata: { loyaltyParams: { storeId: $storeId } } }
    ) {
      label
      id
      description
    }
  }
`);
exports.default = AllCategoriesQuery;
